
import React from 'react';
// functions
import { decimalOrBust } from '../../utilities/currency';

// components
import BasketItem from './BasketItem';
import BundleBasketItem from './BundleBasketItem';
import VirtualPackageBasketItem from './VirtualPackageBasketItem';

function renderSofaGlideItem(parent, entries) {
  const glideEntry = entries[parent.linkedSofaGlide.entryNumber];
  const entryForDisplay = {
    ...entries[parent.linkedSofaGlide.entryNumber],
    product: { ...glideEntry.product, range: 'SofaGlide', scoopImage: 'https://images.sofology.co.uk/image/upload/v1563263370/Checkout/Sofaglide_small.png' },
    wasPrice: { value: parent.linkedSofaGlide.price.value },
    totalPrice: { value: parent.linkedSofaGlide.price.value * parent.quantity }
  };
  
  return <BasketItem item={entryForDisplay} key={`basket-item-${parent.linkedSofaGlide.entryNumber}-${parent.product.code}-sofaglideitem`} hideQuantity hideDiscount />
}

function renderBasketItem(item, entries, index) {
  if(item.isSofaGlide) return null;
  let LineComponent = null;
  if (item.stockType === 'Ex-Display') {
    LineComponent =<BundleBasketItem item={item} key={`basket-item-${item.entryNumber}`} />
  } else {
    LineComponent = <BasketItem item={item} key={`basket-item-${item.entryNumber}-${item.product.code}`} />
  }
  return (
    <React.Fragment key={`basket-item-component-${index}`}>
      {LineComponent}
      {item.linkedSofaGlide && renderSofaGlideItem(item, entries)}
    </React.Fragment>
  );
}

function HybrisBasket({ entries = [], deliveryCost = {}, totalPriceWithTax = {},
  totalDiscounts = {}, discounts }) {
  const hasDelivery = deliveryCost.value;
  const hasDiscount = totalDiscounts.value;

  // separate regular items and virtual packages
  const parsedItems = entries.reduce((acc, entry) =>
    entry.swkUniqueToken ?
      { ...acc, virtual: acc.virtual.concat([entry]) } :
      { ...acc, items: acc.items.concat([entry]) }
  , { items: [], virtual: [] });

  // group virtual package items together
  const virtualPackages = parsedItems.virtual.reduce((acc, item) => {
    acc[item.swkUniqueToken] = (acc[item.swkUniqueToken] || []).concat([item]);
    return acc;
  }, {});

  return (
    <ul className="basket u-padding-top-small u-padding-x-small u-padding-bottom-small">

      {parsedItems.items.length &&
        parsedItems.items.map((item, index) => renderBasketItem(item, entries, index))}

      {Object.keys(virtualPackages).map(swkUniqueToken => (
        <VirtualPackageBasketItem
          key={`virtual-package${swkUniqueToken}`}
          items={virtualPackages[swkUniqueToken]}
          discount={discounts.find(i => i.swkUniqueToken === swkUniqueToken)}
        />)
      )}

      {hasDelivery ? (
        <PriceRow
          rowClass="u-padding-top-small"
          item={'Delivery'}
          value={`£${decimalOrBust(deliveryCost.value)}`}
        />
      ) : null}

      {hasDiscount ? (
        <PriceRow
          rowClass={!hasDelivery ? 'u-padding-top-small' : ''}
          item={'Discounts'}
          value={`£${decimalOrBust(totalDiscounts.value)}`}
        />) : null}

      <PriceRow
        rowClass={!hasDelivery && !hasDiscount ? 'u-padding-top-medium u-padding-bottom-tiny' : ''}
        item={'Total'}
        value={`£${decimalOrBust(totalPriceWithTax.value)}`}
      />
      
    </ul>
  );
}


function PriceRow({ item, value, bold = false, rowClass = '' }) {
  return (
    <li className={`price__row__overide ${rowClass}`}>
      <div className="basket__item price-row">
        {item}
      </div>
      <div className={'basket__value u-padding-left-small'}>
        {bold ? <strong>{value}</strong> : value}
      </div>
    </li>
  );
}

export default HybrisBasket;



// WEBPACK FOOTER //
// ./src/parts/HybrisBasket/index.js